var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.494,
    height: 67.802,
    viewBox: "0 0 67.494 67.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285.283 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.283 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.891,218.026a33.163,33.163,0,0,1,66.265-.327c.022.483.035.967.032,1.452a32.652,32.652,0,0,1-4.593,16.577.472.472,0,0,0-.043.4l5.8,17.377a.3.3,0,0,1-.381.385l-18.044-5.826a.474.474,0,0,0-.368.033,33.466,33.466,0,0,1-15.67,3.827,33.074,33.074,0,0,1-33.015-33.06C61.872,218.621,61.891,218.026,61.891,218.026Z",
    transform: "translate(-61.871 -186.1)",
    fill: "#28aff7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 276.912, -63.089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.627,200.2a2.664,2.664,0,0,1-3.756,0l-7.5-7.5a2.664,2.664,0,0,1,0-3.756l1.771-1.771a1.22,1.22,0,0,0,0-1.726l-5.061-5.061a1.214,1.214,0,0,0-1.712-.014l-.009.009c-4.51,4.51-2.607,13.726,4.251,20.583s16.073,8.761,20.583,4.251l.009-.009a1.214,1.214,0,0,0-.014-1.712l-5.061-5.061a1.22,1.22,0,0,0-1.726,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCallIcon);
export default __webpack_public_path__ + "static/media/mobile-call-icon.776027426d5ee5409fa72482a289f6b6.svg";
export { ForwardRef as ReactComponent };